import { motion } from "framer-motion";
import { Flower2, Package, RotateCcw, Truck } from "lucide-react";
import { BuyButton } from "./BuyButton";

const EASE = [0.16, 1, 0.3, 1];

export const FinalCTA = () => (
  <section id="ritual" data-testid="final-cta-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.98 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: EASE }}
        className="relative overflow-hidden rounded-[2.5rem] bg-espresso px-8 py-16 text-center sm:px-16 sm:py-24 lg:py-28"
      >
        <div className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-terracotta/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-28 -right-20 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
        <Flower2
          size={220}
          strokeWidth={0.4}
          className="pointer-events-none absolute -right-10 -top-10 text-linen/[0.06]"
        />

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-rose"
        >
          Begin Today
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.4, ease: EASE }}
          className="mx-auto max-w-3xl font-serif text-3xl font-medium leading-[1.12] tracking-tight text-linen sm:text-5xl"
        >
          Your happiest days are
          <em className="italic text-rose"> already happening.</em>
          <br />
          Start writing them down.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.55, ease: EASE }}
          className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-linen/70 sm:text-lg"
        >
          Gift yourself — or someone you love — the simple practice of
          gratitude. Paperback, 120 pages, ready to ship from Amazon.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
          className="mt-10 flex flex-col items-center gap-7"
        >
          <BuyButton
            testId="final-cta-buy-now-button"
            label="Buy Now on Amazon — $12.99"
            dark
            className="px-9 py-4 text-base"
          />
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs font-medium uppercase tracking-[0.16em] text-linen/50">
            <span className="flex items-center gap-2">
              <Truck size={14} className="text-rose/80" /> Prime Shipping
            </span>
            <span className="flex items-center gap-2">
              <RotateCcw size={14} className="text-rose/80" /> Easy Returns
            </span>
            <span className="flex items-center gap-2">
              <Package size={14} className="text-rose/80" /> Gift-Ready
            </span>
          </div>
        </motion.div>
      </motion.div>
    </div>
  </section>
);
